import React from 'react';
import { TopNavigation } from '@amzn/awsui-components-react';

const TopNav: React.FC = () => {
  return (
    <TopNavigation
      identity={{
        href: "/",
        title: "Bluey Tool Manager"
      }}
      utilities={[
        {
          type: "menu-dropdown",
          text: "User",
          items: [
            { id: "profile", text: "Profile" },
            { id: "logout", text: "Logout" }
          ]
        }
      ]}
    />
  );
};

export default TopNav;
